import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const FreezeListingModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "FreezeListingModalContainer" */
      './FreezeListingModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
